﻿import { LiveDataSetStation, Status } from "../API/LiveData/LiveDataSet";
import { DefaultParameterDefinitions } from "../DefaultParameterDefinitions";
import { MainSite } from "../MainSite";
import { GetWarningThreshold, WarningGroup } from "../Model/WarningGroup";
import { ParameterGroupInfo } from "../ParameterGroupInfoSet";
import { IStationValueFormatter, IStationValueObject } from "./IStationValueFormatter";

declare var sprintf;

export class MaxProfileDepthVariationFormatter implements IStationValueFormatter {

    constructor(protected profileGroup: ParameterGroupInfo) {
    }

    public getShortName(): string {
        return this.profileGroup.ShortName;
    }

    public getUnits(): string {

        return MainSite.getUnitConverter().getConvertedUnits(this.profileGroup.Units, this.profileGroup.Id);
    }

    public getParameterGroupInfo(): ParameterGroupInfo {
        return this.profileGroup;
    }

    public getDescription(): string {
        return this.profileGroup.Description;
    }

    public getId(): string {
        return this.profileGroup.Id;
    }

    public getSensorId(): string | undefined {
        return undefined;
    }

    public plottable(): boolean {
        return false;
    }

    public axisMin(): number {
        return null;
    }

    public axisMax(): number {
        return null;
    }

    public plotLines(): boolean {
        return false;
    }

    public format(liveDataSetStation: LiveDataSetStation, warningRules?: WarningGroup): IStationValueObject {

        // the default if parameter has never existed
        var valueObject: IStationValueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Timestamp: null,
            Sensor: null
        }

        if (liveDataSetStation?.GroupValues && this.profileGroup.Id in liveDataSetStation?.GroupValues) {

            //var parameter: LiveDataSetValue = liveDataSetStation.GroupValues[this.profileGroup.Id][0];
            //var parameter: Partial<LiveDataSetValue> = liveDataSetStation.GroupValues[this.profileGroup.Id][0];
            // TODO: Do not cast as any! Find type definition.
            var parameter = liveDataSetStation.GroupValues[this.profileGroup.Id][0] as any;

            var paramDef = MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id]
                .Sensors[parameter.Sensor]
                .Parameters[parameter.Parameter]
                .Variants[0]
                .ParameterDefinition;

            if ((!paramDef || paramDef.Default) && parameter.Parameter in DefaultParameterDefinitions.Parameters) {
                paramDef = DefaultParameterDefinitions.Parameters[parameter.Parameter];
            }

            // the default if parameter exists but has expired
            valueObject = {
                Value: '///',
                Status: parameter.ExpiryStatus,
                WarningThreshold: null,
                ParameterDefinition: paramDef,
                Timestamp: parameter.Timestamp,
                Sensor: parameter.Sensor
            }

            if (parameter.Value != null && parameter.Value.Components?.length > 0 && typeof parameter.Value.Components?.at(-1).Depth == 'number' && (parameter.ExpiryStatus == Status.Good || parameter.ExpiryStatus == Status.Expiring)) {

                const value = parameter.Value.Components.at(-1).Depth;

                //// Convert speed according to units
                let unitsConversionSet = MainSite.getUnitConverter().getConversionSet(this.profileGroup.Units, this.profileGroup.Id);

                if (this.profileGroup.Format) {

                    if (unitsConversionSet) {
                        valueObject.Value = sprintf(this.profileGroup.Format, unitsConversionSet.convertValue(value));
                    } else {
                        valueObject.Value = sprintf(this.profileGroup.Format, value);
                    }

                    if (warningRules) {
                        valueObject.WarningThreshold = GetWarningThreshold(warningRules, value, this.profileGroup, liveDataSetStation);
                    }
                } else {
                    valueObject.Value = (MainSite.getUnitConverter().convert(value, this.profileGroup.Units, this.profileGroup.Id)).toString();
                }

            }
        }

        return valueObject;
    }
}